import React from 'react';
import {observer} from 'mobx-react';
import {withStore} from "../../hocs";
import {Link} from 'react-router-dom';
import {ISectionMenuL1, ISectionMenuL2} from '../../interface/ISection';
import {HelperCatalog} from "../../helper/HelperCatalog";


// @ts-ignore
@withStore
@observer
export class SidebarLeft extends React.Component {
    render() {

        // @ts-ignore
        const {store} = this.props;
        const {arSection} = store?.componentCatalogSectionStore;
        const {setPageCatalogL1, setPageCatalogL2} = store?.pageCatalogStore;
        const {includeUserLoyaltyProgram} = store?.mainStore;

        return (
            <>
                {arSection.length ? <div className="sidebar sidebar_left">
                    <Link to="/catalog/filter/isSellout-is-true">
                        <button style={{marginTop: 31,marginBottom: 0, width: "100%", backgroundColor: "#E1EFFA",}} className="to-basket__btn " >
                            <span style={{color: "red", fontWeight: "bold"}} className="to-basket__text ">% РАСПРОДАЖА</span>
                        </button>
                    </Link>
                    {includeUserLoyaltyProgram ?   <Link to="/catalog/filter/isIncludeLoyaltyProgram-is-true">
                        <button style={{marginTop: 21,marginBottom:-10, width: "100%", backgroundColor: "#E1EFFA",}} className="to-basket__btn " >
                            <span style={{color: "black", fontWeight: "bold", display: "flex", }} className="to-basket__text ">
                                <img src="/img/ico/bonusIcon.png"
                                     width="20px"
                                     style={{mixBlendMode: 'multiply', marginRight: 5}}/>
                                <div style={{marginTop: 5}}>
                                    БОНУСНЫЕ ТОВАРЫ
                                </div>

                            </span>
                        </button>
                    </Link> : null}

                    <div className="sidebar-wrapper">
                        {arSection.map(((lev1: ISectionMenuL1) => (
                            <div className="sidebar-item"  key={'l1' + lev1.id}>
                                <Link  onClick={() => setPageCatalogL1(lev1)} to={HelperCatalog.getUrlList(lev1, null)}>
                                {lev1.svgSectionLeft}
                                </Link>
                                <div className="sidebar-wrapper-bg" onClick={() => setPageCatalogL1(lev1)}>
                                    <Link to={HelperCatalog.getUrlList(lev1, null)}
                                          className="sidebar-item__title">{lev1.name}</Link>
                                </div>
                                {lev1.SectionChild.length ? (<ul className="sidebar-menu">
                                    {lev1.SectionChild.map((lev2: ISectionMenuL2) => (
                                        <li key={'l2' + lev2.id} onClick={() => setPageCatalogL2(lev1, lev2)}>
                                            <Link to={HelperCatalog.getUrlList(lev1, lev2)}>
                                                <span>{lev2.name}</span>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>) : null}
                            </div>)))}
                    </div>
                    <Link to="/brands">
                        <button style={{marginTop: 20, width: "100%" }} className="to-basket__btn " >
                            <span className="to-basket__text ">НАШИ БРЕНДЫ</span>
                        </button>
                    </Link>

                </div> : null}
            </>
        );
    }
}


